import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconCalendar = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path d="M4 6.5C4 5.94772 4.44772 5.5 5 5.5H19C19.5523 5.5 20 5.94772 20 6.5V19.5C20 20.0523 19.5523 20.5 19 20.5H5C4.44772 20.5 4 20.0523 4 19.5V6.5Z" stroke="currentColor" strokeWidth="1.5" />
      <path d="M4.59375 11.5H20" stroke="currentColor" strokeWidth="1.5" />
      <path d="M7.5 3V7.5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M16.5 3V7.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export default IconCalendar
